// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import colors from '../common/components/ui/colors';
import withLocalized from '../localization/withLocalized';

const StyledContent = styled.div`
  text-align: center;
  line-height: 1.2em;
  a {
    color: ${colors.BRAND_GREEN};
    cursor: pointer;
  }

  header {
    max-width: 80%;
    margin: 0 auto;
    margin-bottom: 3rem;
    h3 {
      font-size: 1.45rem;
      font-weight: 700;
      color: ${colors.BRAND_GREEN};
      margin-bottom: 1rem;
    }
  }

  section {
    h4 {
      font-weight: 700;
      color: ${colors.BRAND_GREEN};
    }
    ul {
      li {
        margin-bottom: 1rem;
      }
    }
    ul{
      margin-left: 0;
      list-style: none;
      padding-left: 0;
    }
    h4{
      margin-bottom: 0;
    }
    p{
      margin-top: 0;
    }
  }
`;

class BookingHelp extends Component {
  render() {
    const { localized } = this.props;
    return (
      <StyledContent>
        <header>
          <h3>{localized('booking.help.title')}</h3>
          <p>{localized('booking.help.body')}</p>
        </header>
        <section>
          <ul>
            <li>
              <h4>{localized('booking.help.support_email_title')}</h4>
              <p>{localized('booking.help.support_email_body')}</p>
            </li>
          </ul>
        </section>
      </StyledContent>
    );
  }
};

export default withLocalized(BookingHelp);



// WEBPACK FOOTER //
// ./src/modules/booking/BookingHelp.js